import { IPaymentRecord, IRecentPaymentsGetResult, IUpcomingPaymentGetResult } from "types/Api/Payment/paymentRecord";


export const getRecentPayments = (state: any): IPaymentRecord[] => state.recentPayments.recentPayments;
export const getUpcomingPayment = (state: any): IPaymentRecord => state.upcomingPayment.upcomingPayment;

